module.exports = __webpack_public_path__ + "img/Dantam Bridal 23.8461e937.jpg";